import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { TouristicPlace } from '../../../../types/types';

type Props = {
  place: TouristicPlace;
};

const TouristicPlaceCard: React.FC<Props> = ({ place }) => {
  return (
    <Box sx={{ width: { xs: '100%', sm: '45%', md: '345px' } }}>
      <Card sx={{ height: '100%' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={place.image}
          title={place.title}
        />
        <CardContent>
          <Typography gutterBottom variant="h5">
            {place.title}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {place.description}
          </Typography>
        </CardContent>
        <CardActions>
          <Button href={place.link} size="small">
            Plus d'informations
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default TouristicPlaceCard;
